import type { CoreFamilyId } from './BuiltinToolsScene.transform';
import type { AppMcpSubfamilyId } from './BuiltinToolsScene.transform';

/** True when two sets contain the same members. */
export function setsEqual<T>(a: ReadonlySet<T>, b: ReadonlySet<T>): boolean {
  if (a.size !== b.size) return false;
  for (const item of a) {
    if (!b.has(item)) return false;
  }
  return true;
}

/**
 * Warning-banner family-unit count (F22 pinned rule).
 */
export function countDisabledPlatformFamilyUnits(
  coreFamiliesDisabled: ReadonlySet<CoreFamilyId>,
  appMcpSubfamiliesDisabled: ReadonlySet<AppMcpSubfamilyId>,
): number {
  let count = 0;
  for (const familyId of ['user_memory', 'artifacts', 'project_files'] as const) {
    if (coreFamiliesDisabled.has(familyId)) count += 1;
  }
  if (coreFamiliesDisabled.has('app_mcp')) {
    count += 1;
  } else {
    count += appMcpSubfamiliesDisabled.size;
  }
  return count;
}

/** Boundary copy shown under specific sub-family rows (F22). */
export const APP_MCP_SUBFAMILY_BOUNDARY_NOTES: Partial<Record<AppMcpSubfamilyId, string>> = {
  'platform.documents':
    'Project editor loses agent editing while disabled (user editing is unaffected).',
  'platform.workflow': 'In-flight runs are not cancelled — exposure-only disable.',
};
